const React = require('react');
const { Provider } = require('./context');
const HopsFetchRuntimeMixin = require('./mixin.runtime-common.js');

class HopsFetchBrowserMixin extends HopsFetchRuntimeMixin {
  enhanceElement(reactElement) {
    const { fetch, fetchJson } = this;

    return React.createElement(
      Provider,
      { value: { fetch, fetchJson } },
      reactElement
    );
  }
}

module.exports = HopsFetchBrowserMixin;
